import { styled } from '@mui/material/styles';

export const Divider = styled('div')`
  border-bottom: 0.5px solid rgba(182, 187, 196, 0.4);
  width: 100%;
`;
